export function DataTable({ columns, rows, empty = 'Kayit yok' }) {
  if (!rows?.length) return <div className="muted">{empty}</div>
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((c) => (
                <td key={c.key}>{c.render ? c.render(row) : (row[c.key] ?? '-')}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export function Pager({ meta, onPage }) {
  if (!meta || meta.pages <= 1) return null
  return (
    <div className="pager">
      <button className="btn-ghost" disabled={meta.page <= 1} onClick={() => onPage(meta.page - 1)}>
        Onceki
      </button>
      <span className="muted">
        {meta.page} / {meta.pages} &middot; {meta.total} kayit
      </span>
      <button
        className="btn-ghost"
        disabled={meta.page >= meta.pages}
        onClick={() => onPage(meta.page + 1)}
      >
        Sonraki
      </button>
    </div>
  )
}
